import { Autocomplete, TextField } from "@mui/material";
import { Component, createRef } from "react"; // Importe o createRef
import { httpGet } from "../util/http";

export default class UsuarioSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            loading: false,
        }
        // 1. Criamos a referência
        this.inputRef = createRef();
    }

    componentDidMount() {
        this.setState({ loading: true });
        httpGet('/inventarios/users/' + this.props.unidadeId,
            usuarios => {
                this.setState({
                    items: usuarios,
                    loading: false
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
            true
        );
    }

    // 2. Criamos uma função para lidar com a mudança
    handleChange = (event, value) => {
        if (this.props.onChange) {
            this.props.onChange(value);
        }

        // 3. Força o "blur" (tirar o foco) do input logo após a seleção
        if (this.inputRef.current) {
            this.inputRef.current.blur();
        }
    }

    render() {
        return (
            <Autocomplete 
                {...this.props.props}
                noOptionsText="Nenhum usuário"
                loadingText="Carregando..."
                openText="Abrir lista"
                loading={this.state.loading}
                value={this.props.value} 
                options={this.state.items}
                size="small"
                sx={{ ...this.props.sx }}
                getOptionLabel={option => option.nome || ""}
                getOptionKey={option => option.id}
                
                // 4. Usamos a nova função aqui
                onChange={this.handleChange}
                
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        // 5. Atribuímos a ref ao input real
                        inputRef={this.inputRef} 
                        error={this.props.error === true}
                        helperText={this.props.error === true ? "Escolha um usuário" : null}
                        label={'Usuários' + (this.props.required ? '*' : '')} 
                    />
                )}
            />
        );
    }
}